const state = {
    isLoading: false,

}

const mutations = {
    START_LOADING: (state) => {
        state.isLoading = true
    },
    END_LOADING: (state) => {
        state.isLoading = false
    }
}

const actions = {
    startLoading: ({ commit }) => {
        commit('START_LOADING')
    },
    endLoading: ({ commit }) => {
        commit('END_LOADING')
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/loading.js